<template>
  <a-modal
    ref="createModal"
    title="完工-零部件"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
      <a-button :disabled="selectedRows.length === 0" @click="confirm()" :loading="wglbjLoading" type="primary">保存</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :row-selection="rowSelection"
      :scroll="{ x: 1200 }"
    >
      <span slot="completedSublibraryTitle">
        <i class="toRequired">*</i>子库
      </span>
      <span slot="completedLocationTitle">
        <i class="toRequired">*</i>货位
      </span>
      <span slot="quantityCompletedTitle">
        <i class="toRequired">*</i>入库数量
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(typeList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :focusGet="item.focusGet ? item.focusGet : false"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
            />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiMesDispatchWipCompletion } from '@/api/mes/workOrderManage/workOrderSent'
// 表单字段
export default {
  props: {},
  data () {
    return {
      visible: false,
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          width: 150
        },
        {
          title: '成品',
          dataIndex: 'assembly',
          width: 150
        },
        {
          title: '规格描述',
          dataIndex: 'description',
          width: 100,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUomCode',
          width: 80
        },
        {
          // title: '子库',
          dataIndex: 'completedSublibrary',
          scopedSlots: { customRender: 'completedSublibrary', title: "completedSublibraryTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '货位',
          dataIndex: 'completedLocation',
          scopedSlots: { customRender: 'completedLocation', title: "completedLocationTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '入库数量',
          dataIndex: 'quantityCompletedSave',
          scopedSlots: { customRender: 'quantityCompletedSave', title: "quantityCompletedTitle" },
          width: 100,
          type: "inputNumber"
        },
        {
          title: '批次',
          dataIndex: 'lotNumber',
          width: 150
        },
        {
          title: '计划数量',
          dataIndex: 'planQuantity',
          width: 100
        },
        {
          title: '已完工数量',
          dataIndex: 'quantityCompleted',
          width: 100
        },
        {
          title: '已入库数量',
          dataIndex: 'receivedQuantity',
          width: 100
        },
        {
          title: '待入库数量',
          dataIndex: 'waitStocked',
          width: 100
        },
        {
          title: '组装中心工单号',
          dataIndex: 'upstreamWorkNumber',
          width: 150
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: [],
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      desOrganizationCode: "",
      wipEntityId: "",
      originTableList: [],
      wglbjLoading: false
    }
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (arr, row) {
      this.originTableList = arr
      arr.forEach((item, index) => {
        item.indexId = index + 1
      });
      this.typeList = arr
      this.desOrganizationCode = row.desOrganizationCode
      this.wipEntityId = row.id
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        wipEntityName: this.originTableList[0].wipEntityName,
        assembly: this.originTableList[0].assembly,
        description: this.originTableList[0].description,
        primaryUomCode: this.originTableList[0].primaryUomCode,
        completedSublibrary: "",
        completedLocation: "",
        quantityCompletedSave: "",
        lotNumber: this.originTableList[0].lotNumber,
        planQuantity: this.originTableList[0].planQuantity,
        quantityCompleted: this.originTableList[0].quantityCompleted,
        waitStocked: this.originTableList[0].waitStocked,
        upstreamWorkNumber: this.originTableList[0].upstreamWorkNumber,
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
      this.$emit('handle-success')
    },
    // 保存
    confirm () {
      let flag = false
      const arr = []
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].completedSublibrary || !this.typeList[i].completedLocation) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (!this.typeList[i].quantityCompletedSave || Number(this.typeList[i].quantityCompletedSave) <= 0) {
          this.$message.warning('完工数量不能为空且需大于0')
          flag = true
          return
        }
        // if (this.typeList[i].waitStocked && Number(this.typeList[i].quantityCompletedSave) > Number(this.typeList[i].waitStocked)) {
        //   this.$message.warning('完工数量不允许大于可完工数量')
        //   flag = true
        //   return
        // }
        const obj = {
          sublibrary: this.typeList[i].completedSublibrary,
          location: this.typeList[i].completedLocation,
          qty: this.typeList[i].quantityCompletedSave
        }
        arr.push(obj)
      }
      if (flag) {
        return false
      }
      const param = {
        wipEntityId: this.wipEntityId,
        warehousing: arr
      }
      this.wglbjLoading = true
      apiMesDispatchWipCompletion(param).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
        } else {
          this.$message.error(response.msg)
        }
        this.wglbjLoading = false
      }).catch(e => {
        this.wglbjLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "completedSublibrary") {
        return { organizationCode: this.desOrganizationCode }
      }
      if (dataIndex === "completedLocation") {
        return { subinventoryCode: record.completedSublibrary }
      }
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  // height: 400px;
  overflow-y: scroll;
}
/deep/.ant-input-number{
  width: 80px !important;
}
/deep/.ant-select{
  width: 140px !important;
}
</style>
